import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, Method } from "axios";

import { Schema } from "@cak-legacy/generation-core";

import { FormSchemaModelMapper } from "../mapper/FormSchemaModelMapper";
import { AbstractFieldModel } from "../client/model/fields/abstractFieldModel";

export class ConfiguratieService {
  constructor(private readonly baseUrl: string, private readonly axiosInstance: AxiosInstance = axios) {}

  private readonly getAxiosRequestConfig = (
    url: string,
    headers: Record<string, any>,
    method: Method
  ): AxiosRequestConfig => ({
    method,
    url,
    headers: {
      ...headers,
      Accept: "application/json"
    }
  });

  getConfiguration = (path: string): Promise<Schema> => {
    return this.getData(path).then((response: AxiosResponse) => {
      const data = response.data as {
        [key: string]: AbstractFieldModel;
      };

      return new FormSchemaModelMapper(this.baseUrl).map(data);
    });
  };

  getValues = (path: string): Promise<unknown> => {
    return this.getData(path).then((response: AxiosResponse) => {
      return response.data;
    });
  };

  getData = (path: string): Promise<unknown> => {
    const url = `${this.baseUrl}/api/v1/${path}`;
    return this.axiosInstance.request(this.getAxiosRequestConfig(url, {}, "GET")).catch((error: any) => {
      throw error;
    });
  };
}
